import Form from './Form';
import AccordionForm from './FormFunctions';
import '../App.css';
import React, { useState, useEffect } from 'react';
import Header from './Header';  // Импорт нового компонента Header
import Footer from './Footer';


// function Header(){
//     return(
//       <div className="container-sm">
//         <nav className='App-header navbar navbar-expand-lg'>
//           <a className="navbar-brand" href="#">
//             <div className="App-logo"></div>
//           </a>
//           <button className="navbar-toggler" type="button" data-bs-toggle="collapse" 
//           data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" 
//           aria-expanded="false" aria-label="Toggle navigation">
//             <span className="navbar-toggler-icon"></span>
//           </button>
//           <div className="navbar-collapse collapse" id="navbarSupportedContent">
//                 <div className="navbar-nav container-sm">
//                 <a className="nav-item nav-link font-size250" href="#section-fixpreis">Fixpreis</a>
//                 <a className="nav-item nav-link font-size250" href="#section-quality">Qualität</a>
//                 <a className="nav-item nav-link font-size250" href="#section-buchen">Buchen</a>
//               </div>
//             </div>
//         </nav>
//       </div>
//     )
//   }

function Main({ mServices }) {

  return (
    <>
      <div id="section-intro-black" className='intro-section'>
        {/* <div className="container-sm"> */}
        <div className='intro-text'>
          <div className='intro-text-container headerText'>
            <div className='title1'>
              <h1 className='opensans-regular font-size500'>Service zum Fixpreis</h1>
              <br />
              <p className='opensans-light font-size350'>für Motorräder der Marke BMW mit Boxermotoren ab Baujahr 2014 (wassergekühlt)</p>
            </div>
            <div className='line'></div>
            <div className='title2'>
              <p> Gilt auch für Motorräder innerhalb der gesetzlichen und erweiterten Gewährleistungspflicht des Herstellers.</p>
            </div>
          </div>
          <div>
          </div>
        </div>
        {/* </div> */}
      </div>
      {/* <div id="section-intro-blue" className="bg-blue w-100">
        <div className='container-sm pt-5 pb-5 font-size200'>
          <p> Gilt auch für Motorräder innerhalb der gesetzlichen und erweiterten Gewährleistungspflicht des Herstellers.</p>
        </div>
      </div> */}

      {/* <div id="section-intro-gray" className="bg-gray w-100">
        <div className='container-sm pt-3 pb-3'>
          <div className="rowToColumn">
            <div className="rowToColumn-item flexb-30">
              <div className="card blueBorder mb-3">
                <div className="card-body font-size200">
                  <a href="#section-fixpreis">Service zum Fixpreis</a>
                </div>
              </div>
            </div>
            <div className="rowToColumn-item flexb-30">
              <div className="card blueBorder mb-3">
                <div className="card-body font-size200">
                  <a href="#section-quality">Original Qualität</a>
                </div>
              </div>
            </div>
            <div className="rowToColumn-item flexb-30">
              <div className="card blueBorder mb-3">
                <div className="card-body font-size200">
                  <a href="#section-buchen">nur online buchbar</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div id="section-fixpreis" className="bg-white w-100">
        <div className="container-sm pt-5 pb-5">
          {/* <h2 className='font-size400'>Service zum Fixpreis</h2> */}
          <div className="centered-double-item">
            <p className="double-item-heading font-size250">Exakt nach Herstellervorgaben </p>
            <p className="double-item-body font-size150">(inkl. Tausch der Bremsflüssigkeit, wenn erforderlich bzw. laut Herstellervorgaben vorgesehen, gültig 2013)</p>
          </div>
          <div className="serviceOptions pt-3">
            {mServices.map(function (m_option) {
              return (
                <div className="serviceOption-item" key={m_option.id}>
                  <div className="serviceOption-card card">
                    <div className="card-body opensans-light font-size200">
                      <p>{m_option.name}</p>
                      <hr></hr>
                      <div className='servicePreis opensans-regular'>
                        <p>{m_option.preis},-€</p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div id="section-quality" className="bg-blue w-100">
        <div className="container-sm opensans-regular pt-5 pb-5 quality">
          <div className="rowToColumn">


            <h2 className='font-size400 container_30 rowToColumn-item'>Original Qualität</h2>



            <div className='line2'></div>




            <div className="opensans-light font-size175 rowToColumn-item flexb-60">
              <p>
                Höchste Qualität ist selbstverständlich.<br />
                Service- und Ersatzteilqualität sind bei uns starke Versprechen an die wir uns halten und an denen wir gerne gemessen werden.
              </p>
              <p>
                Als Fachwerkstatt servicieren wir dein Motorrad so, dass sämtliche Gewährleistungen des Herstellers erhalten bleiben.
              </p>
              <p>
                Unsere Qualitätsstandards prüfen wir im Sinne unserer Kunden regelmäßig und bessern nach, wo es nötig ist. Darauf kannst du dich verlassen
              </p>
            </div>
          </div>



        </div>
      </div>
      {/* <div id="section-buchen" className="bg-white">
        <div className="container-sm pt-3 pb-3">
          <h2 className='font-size400 container_30'>Und los geht's</h2>
          <div className="centered-double-item">
            <div className="double-item-element-left">
              <p className="double-item-heading font-size250">Abholen:</p>
            </div>
            <div className="double-item-element-right">
              <p className="double-item-heading font-size250">Info per SMS</p>
              <p className="double-item-body font-size150">Wir informieren dich per SMS, wenn dein Motorrad abholbereit ist. Meistens noch am selben Tag.</p>
            </div>
          </div>
        </div>
      </div> */}
      <div id="section-buchen" className="bg-white">
        <div className="container-sm pt-3 pb-3 formScroll">
          <h2 className='font-size400 container_30 blinking-text'>Und los geht's</h2>
          <div className="centered-double-item">
            <div className="double-item-element-left">
              <p className="double-item-heading font-size250">Abholen:</p>
            </div>
            <div className="double-item-element-right">
              <p className="double-item-heading font-size250">Info per SMS</p>
              <p className="double-item-body font-size150">Wir informieren dich per SMS, wenn dein Motorrad abholbereit ist. Meistens noch am selben Tag.</p>
            </div>
          </div>
        </div>

        {/* Кнопка со стрелкой вниз */}
        <div className="scroll-down-button-container">
          <button
            className="scroll-down-button"
            onClick={() => {
              const nextSection = document.getElementById('form'); // Замените на реальный ID следующей секции
              const navbar = document.querySelector('.App-header'); // Класс вашего навбара
              const navbarHeight = navbar ? navbar.offsetHeight : 0;

              if (nextSection) {
                const elementPosition = nextSection.getBoundingClientRect().top + window.pageYOffset;
                const offsetPosition = elementPosition - navbarHeight;

                window.scrollTo({
                  top: offsetPosition,
                  behavior: 'smooth',
                });
              }
            }}
          >
            {/* SVG стрелки вниз */}
            <svg
              className="arrow-down"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>

        </div>
      </div>

    </>
  )
}

export default function Home() {
  const [services, setServices] = useState([]);
  const [error, setError] = useState(null);
  const [servicesLoaded, setServicesLoaded] = useState(false);
  const [standorteLoaded, setStandorteLoaded] = useState(false);
  const [standorte, setStandorte] = useState([]);

  useEffect(() => {
    // Выполнение запросов при монтировании компонента
    const baseUrl = process.env.REACT_APP_API_URL;

    // Запрос для items/service
    fetch(`${baseUrl}/items/service?sort=km_limit`)
      .then(res => res.json())
      .then(
        (result) => {
          setServices(result.data);
          setServicesLoaded(true);
        },
        (error) => {
          setError(error);
          setServicesLoaded(true);
        }
      );

    // Запрос для items/standort
    fetch(`${baseUrl}/items/standort`)
      .then(res => res.json())
      .then(
        (result) => {
          setStandorte(result.data);
          setStandorteLoaded(true);
        },
        (error) => {
          setError(error);
          setStandorteLoaded(true);
        }
      );
  }, []);

  return (
    <div className="App">
      {/* <Header /> */}
      <Main mServices={services} />
      <div className='body mt-3'>
        <div className='container-sm formBody'>
          <div className='pb-5'>
            <Form standorte={standorte} services={services}></Form>
          </div>

        </div>
        <Footer />
      </div>

    </div>
  );
}